import { configureStore } from "@reduxjs/toolkit";

import mainReducer from "./components/Main.slice"
import buildTargetsReducer from "./components/BuildTargets.slice"
import marketExplorerReducer from "./components/MarketExplorer.slice"
import reportBuilderReducer from "./components/ReportBuilder.slice"
import reportsBuilderReducer from "./components/Reports.slice"
import audienceBuilderReducer from "./components/Audience.slice"
import minifiedReducer from "./components/Minified.slice"
import insightsReducer from "./components/Insights.slice";
import audienceSizeReducer from "./components/SSPAudience.slice";
import treeMapReportsReducer from "./components/TreeMapReport.slice";
import expandReducer from "./components/Expand.slice";
import featureReducer from "./components/Feature.slice"
import dashboardReportReducer from "./components/DashboardReport.slice";

const rootReducer = {
  main: mainReducer,
  audience: audienceBuilderReducer,
  buildTargets: buildTargetsReducer,
  marketExplorer: marketExplorerReducer,
  reportBuilder: reportBuilderReducer,
  reports: reportsBuilderReducer,
  treemapreports: treeMapReportsReducer,
  minified: minifiedReducer,
  insights: insightsReducer,
  audienceSize: audienceSizeReducer,
  expandstore: expandReducer,
  feature: featureReducer,
  dashboardReport: dashboardReportReducer
};

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
